import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "../footer/footer.component";
import { NavbarComponent } from "../navbar/navbar.component";
import { SidebarComponent } from "../sidebar/sidebar.component";

@Component({
    selector: "app-layout",
    imports: [
        RouterModule,
        CommonModule,
        NavbarComponent,
        SidebarComponent,
        FooterComponent,
    ],
    templateUrl: "./app-layout.component.html",
    styleUrl: "./app-layout.component.scss"
})
export class AppLayoutComponent {
  @Input() isProducerArea: boolean = false;
}
